import React from "react";
//#region types
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ViewPanel, useMountedState } from "components/common";
import Voucher from "./voucher";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { VouchersProps } from "models/propTypes/voucherPropsTypes";

const Vouchers: React.FC<VouchersProps> = (props) => {
  const { getMounted } = useMountedState();
  const [vouchers, setVouchers] = React.useState<WintSuperkollAPIModelAccounting.SimplifiedVoucher[]>();

  React.useEffect(() => {
    props.getVouchersHandler(props.parentId).then((result) => {
      getMounted() && setVouchers(result);
    });
  }, [props.parentId]);

  return vouchers && vouchers.length > 0 ? (
    <ViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TransactionList)}
      icon={IconDefinitionConstants.WList}
    >
      <>
        {vouchers.map((voucher) => (
          <Voucher
            key={`voucher-${voucher.voucherNumber}`}
            parentId={props.parentId}
            voucherNumber={voucher.voucherNumber}
            voucherText={voucher.text ?? ""}
            bookingDate={voucher.bookingDate}
            currency={voucher.currency ?? ""}
            series={voucher.series ?? ""}
            transactions={
              voucher.transactions
                ? voucher.transactions.map((transaction) => ({
                    account: transaction.account,
                    accountName: transaction.accountName ?? "",
                    transactionText: transaction.text ?? "",
                    dimensions: transaction.dimensions ?? [],
                    amount: transaction.amount,
                  }))
                : []
            }
          />
        ))}
      </>
    </ViewPanel>
  ) : (
    <></>
  );
};

export default Vouchers;
